import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ErrorToastContent(props) {
    const injectedProps = props; // ToastContentProps is injected by react-toastify
    return (_jsxs("div", { style: { width: "100%", padding: 0 }, children: [_jsx("p", { children: injectedProps.message }), injectedProps.error && (_jsx("pre", { style: {
                    width: "100%",
                    padding: 0,
                    overflow: "scroll",
                    maxHeight: 300,
                }, children: _jsx("code", { style: { padding: "16px" }, children: injectedProps.error.message }) }))] }));
}
export default ErrorToastContent;
//# sourceMappingURL=ErrorToastContent.js.map